import { render, staticRenderFns } from "./YoutubeIframe.vue?vue&type=template&id=97ac97ae"
import script from "./YoutubeIframe.vue?vue&type=script&lang=js"
export * from "./YoutubeIframe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports